import React from 'react'
import clsx from 'clsx'
import { useMessageContext, useTranslationContext } from 'stream-chat-react'
import MessagingMessageActions from './messaging-message-actions'
import MessagingReactionSelectorWithButton from './messaging-reaction-selector-with-button'
import {
  MessagingActionsIcon,
  MessagingReactionIcon,
  MessagingThreadIcon,
} from './messaging-message-action-icons'

const MESSAGE_ACTIONS = {
  react: 'react',
  reply: 'reply',
}

const MessagingMessageOptions = ({
  ActionsIcon = MessagingActionsIcon,
  displayReplies = true,
  handleOpenThread: propHandleOpenThread,
  ReactionIcon = MessagingReactionIcon,
  theme = 'simple',
  ThreadIcon = MessagingThreadIcon,
}) => {
  const {
    getMessageActions,
    handleOpenThread: contextHandleOpenThread,
    initialMessage,
    message,
    threadList,
  } = useMessageContext()
  const { t } = useTranslationContext()
  const handleOpenThread = propHandleOpenThread || contextHandleOpenThread
  const messageActions = getMessageActions()
  const shouldShowReactions = messageActions.indexOf(MESSAGE_ACTIONS.react) > -1
  const shouldShowReplies =
    messageActions.indexOf(MESSAGE_ACTIONS.reply) > -1 &&
    displayReplies &&
    !threadList

  if (
    !message.type ||
    message.type === 'error' ||
    message.type === 'system' ||
    message.type === 'ephemeral' ||
    message.status === 'failed' ||
    message.status === 'sending' ||
    initialMessage
  ) {
    return null
  }

  return (
    <div
      className={clsx(
        `str-chat__message-${theme}__actions`,
        'str-chat__message-options',
      )}
      data-testid="message-options"
    >
      <MessagingMessageActions ActionsIcon={ActionsIcon} />
      {shouldShowReplies && (
        <button
          aria-label={t('aria/Open Thread')}
          className={clsx(
            `str-chat__message-${theme}__actions__action`,
            `str-chat__message-${theme}__actions__action--thread`,
            'str-chat__message-reply-in-thread-button',
          )}
          data-testid="thread-action"
          onClick={handleOpenThread}
          type="button"
        >
          <ThreadIcon className="str-chat__message-action-icon" />
        </button>
      )}
      {shouldShowReactions && (
        <MessagingReactionSelectorWithButton ReactionIcon={ReactionIcon} />
      )}
    </div>
  )
}

export default MessagingMessageOptions
